import { ChangeDetectorRef, Component, Injector, EventEmitter, Output, Input, HostBinding } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [MakeProvider(ToggleComponent)],
})
export class ToggleComponent extends AbstractValueAccessor {
  @HostBinding('class.disabled')
  @HostBinding('class.pointer-events-none')
  @HostBinding('class.opacity-70')
  private get isToggleDisabled(): boolean {
    return this.isDisabled || this.disabled;
  }

  @Input()
  textTranslationKey: string;

  @Input()
  descriptionTranslationKey: string;

  @Input()
  label: string;

  @Input()
  labelWithColon = true;

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Output()
  changeValue = new EventEmitter<{ toggle: boolean }>();

  constructor(injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
  }

  writeValue(value: any): void {
    super.writeValue(value);
    this.cd.detectChanges();
  }

  onClick(event: MouseEvent): void {
    if (this.isToggleDisabled) {
      return;
    }

    this.value = !this.value;
    this.changeValue.emit({ toggle: this.value });
    event.stopPropagation();
  }
}
